import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, inject, OnInit, ViewChild } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatPaginator, MatPaginatorIntl, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { Router } from '@angular/router';
import { PermissionsService } from '../../services/permissions.service';
import { ServiceCardsService } from '../../services/service-cards.service';
import { MatCardModule } from '@angular/material/card';
import { Card } from '../../models/card.model';
import { MatButtonModule } from '@angular/material/button';
import { getPolishPaginatorIntl } from '../../polish-paginator-intl';

import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
//import { ModalServiceCardComponent } from '../modal-service-card/modal-service-card.component';
import { Integration } from '../../models/integration.model';
import { IntegrationsService } from '../../services/integrations.service';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

@Component({
  selector: 'app-integrations',
  imports: [
    CommonModule,
    MatIconModule,
    MatTableModule,
    MatCardModule,
    MatPaginatorModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule
  ],
  templateUrl: './integrations.component.html',
  styleUrl: './integrations.component.css',
  providers: [{ provide: MatPaginatorIntl, useValue: getPolishPaginatorIntl() }]
})
export class IntegrationsComponent implements OnInit, AfterViewInit {

  //public dialogRef?: MatDialogRef<ModalServiceCardComponent>;
  //readonly dialog = inject(MatDialog);


  public integrations: Integration[] = [];

  public displayedColumns: string[] = [
    'name',
    //'type',
    'cardUuid',
    //'activationTime',
    'active',
    'action'
  ];

  public dataSource = new MatTableDataSource<any>(this.integrations);

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  constructor(
    public router: Router,
    public permissionsService: PermissionsService,
    public integrationsService: IntegrationsService,
  ) {
  }



  ngOnInit(): void {
    this.integrations = [];
    //this.fetchCards();
    this.fetchIntegrations();
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  fetchIntegrations() {
    this.integrationsService.fetchIntegrations()
      .subscribe({
        next: (data: any) => {
          this.integrations = data;
          this.dataSource = new MatTableDataSource<any>(this.integrations);
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
        },
        error: (error: any) => {
          console.error(error);
          if (error.status == 401) {
            this.router.navigate(['/login']);
          }
        }
      });
  }

  doFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    //console.log("do filter arg", filterValue)
    this.dataSource.filter = filterValue.trim().toLowerCase()
  }

  addIntegration() {
    console.log("add integration")
    this.router.navigate(['/integrations/edit', 0]);
    /*this.dialogRef = this.dialog.open(ModalServiceCardComponent, {
      width: '250px',
      data: { type: 'add' }
    });*/
  }

  getStatus(status: boolean) {
    return status ? "Aktywna" : "Nieaktywna";
  }

  fetchCards() {
    this.integrationsService.fetchCards()
      .subscribe({
        next: (data: any) => {
          this.integrationsService.integrationCards = data;
        },
        error: (error: any) => {
          console.error(error);
          if (error.status == 401) {
            this.router.navigate(['/login']);
          }
        }
      });
  }


}
